import React from 'react'
import DatePicker from 'react-datepicker'
import "react-datepicker/dist/react-datepicker.css"
import { StyledDatePickerLabelWrapper, StyledDatePickerLabel, StyledDatePickerContainer, StyledDatePickerDate, StyledDatePickerInput } from './styled';
import Icon from '../Icon';


const CustomInput = React.forwardRef(({ value, onClick, showTimeSelectOnly }, ref) => (
    <StyledDatePickerInput ref={ref} onClick={onClick}>
        <StyledDatePickerDate>{value}</StyledDatePickerDate>
        <Icon name={showTimeSelectOnly ? 'clock' : 'calendar'} />
    </StyledDatePickerInput>
))


export default ({ label, active = true, onClick, showTimeSelectOnly, ...restProps }) => {
    const ref = React.createRef();
    return (
        <StyledDatePickerLabelWrapper onClick={onClick}>
            {
                label &&
                <StyledDatePickerLabel>{label}</StyledDatePickerLabel>
            }
            <StyledDatePickerContainer active={active}>
                <DatePicker {...restProps} showTimeSelectOnly={showTimeSelectOnly} customInput={<CustomInput ref={ref} showTimeSelectOnly={showTimeSelectOnly} />} />
            </StyledDatePickerContainer>
        </StyledDatePickerLabelWrapper>
    )
}
